import { Http } from './http';

export const GetAccountDealer = (params) => Http().get(`/account/dealer-search?${params}`);
